export enum NAVIGATION {
    /**
     * @value Add to navigation (published content only)
     * @description Prompt to add a content to the main navigation and explaining that only published content can be added
     */
    ADD_PUBLISHED_CONTENT = 'NAVIGATION.ADD_PUBLISHED_CONTENT',
    /**
     * @value Add to navigation
     * @description Prompt to add something to the main navigation.
     */
    ADD_TO_NAVIGATION = 'NAVIGATION.ADD_TO_NAVIGATION',
    /**
     * TODO: Delete once ADD_TO_NAVIGATION is in production
     * @value Add to the menu
     */
    ADD_TO_THE_MENU = 'CONTENT_SETTINGS_NAVIGATION',
    /**
     * @value To ease the mobile user experience, navigation is limited to %DEPTH% levels.
     * @description Text to display next to Add section button when depth limit is reached
     */
    DEPTH_LIMIT = 'NAVIGATION.DEPTH_LIMIT',
    /**
     * @value Navigation entries cannot be left empty.
     * @description Appears as an error when at least a navigation entry is left empty in the administration of the mobile configuration
     */
    EMPTY_SECTIONS_WARNING = 'ADMIN.MOBILE.NAVIGATION.SAVE.ERROR.EMPTY_NAVIGATION',
    /**
     * @value Main navigation
     * @description Aria label for the main navigation.
     */
    MAIN_NAVIGATION_ARIA = 'FRONT.NAV.MAIN_NAVIGATION.ARIA',
    /**
     * @value %ENT% moved to the first level
     */
    MOVED_TO_THE_FIRST_LEVEL = 'MOBILE_NAVIGATION.MOVED_TO_THE_FIRST_LEVEL',
    /**
     * @value Parent site navigation
     * @description Aria label for the parent navigation.
     */
    PARENT_NAVIGATION_ARIA = 'FRONT.NAV.PARENT_NAVIGATION.ARIA',
    /**
     * @value Navigation
     * @description Title of the mobile navigation administration
     */
    TITLE = 'ADMIN.MOBILE.NAVIGATION.TITLE',
    /**
     * @value You can add a maximum of %WIDTH% elements within a navigation item.
     * @description Text to display  next to Add element button in admin mobile navigation when max node navigation is reached
     */
    WIDTH_LIMIT = 'NAVIGATION.WIDTH_LIMIT',
    /**
     * @value To ease the use of navigation, limits the number of same-level items to less than %WIDTH%.
     */
    WIDTH_WARNING = 'NAVIGATION.WIDTH_WARNING',
}
